import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetEventDayQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetEventDayQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/event-days/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}